import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useParams, useLocation, useNavigate} from 'react-router-dom';
import axios from 'axios';
import "./PageFetcher.css";
import CustomLoader from "../../../components/ConfirmationModal/CustomLoader";
import {IoMdAdd} from 'react-icons/io';
import Button from '@mui/material/Button';
import {jwtDecode} from 'jwt-decode';
import EntitySelectorDialog from "../../../components/accordion/EntitySelectorDialog";
import NomenclatureEnum from "../../../enums/nomenclatureEnum";

const PageFetcher = () => {
    const {t, i18n} = useTranslation();
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const {pageName} = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [pageData, setPageData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [roleId, setRoleId] = useState('');
    const [showEntityDialog, setShowEntityDialog] = useState(false);
    const [selectedEntities, setSelectedEntities] = useState({entity: null, explanationEntity: null});
    const [nomenclature, setNomenclature] = useState(null);
    const searchParams = new URLSearchParams(location.search);
    const permitUrl = searchParams.get('permiturl');
    const parentId = searchParams.get('parentId');
    const hasSecondStep = NomenclatureEnum.registery === nomenclature

    const fetchPermitType = async () => {
        try {
            const response = await axios.get(`${baseURL}/GetPermitTypeByID?Id=${permitUrl}`);
            setNomenclature(response.data.data.orderDepartment)

        } catch (error) {
        }
    };
    useEffect(() => {
        void fetchPermitType();
    }, []);

    useEffect(() => {
        if (pageData) {
            document.title = pageData.name ?? "TCSA";
        }
    }, [pageData]);

    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch {
                setRoleId('');
            }
        }
    }, []);

    useEffect(() => {
        const fetchPageData = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllPageByUrl?Url=${pageName}`);
                if (response.data.success && response.data.data) {
                    setPageData(response.data.data);
                } else {
                    navigate("/notfound");
                }
            } catch {
                navigate("/notfound");
            } finally {
                setTimeout(() => setIsLoading(false), 1000);
            }
        };

        if (pageName) void fetchPageData();
    }, [pageName, t]);


    const handleStart = () => setShowEntityDialog(true);

    const handleSelect = (type, step) => {
        if (!showEntityDialog) return;

        if (!hasSecondStep) {
            setSelectedEntities({ entity: type, explanationEntity: null });
            setShowEntityDialog(false);

            const path = roleId === "USER"
                ? `/dashboard/newcase?id=${permitUrl}&parentId=${parentId}&entity=${type}`
                : `/login?returnUrl=${permitUrl}&parentId=${parentId}&entity=${type}`;
            navigate(path);
            return;
        }

        if (step === 1) {
            setSelectedEntities(prev => ({ ...prev, entity: type }));
        } else {
            const updated = { ...selectedEntities, explanationEntity: type };
            setSelectedEntities(updated);
            setShowEntityDialog(false);

            const path = roleId === "USER"
                ? `/dashboard/newcase?id=${permitUrl}&parentId=${parentId}&entity=${updated.entity}&explanationEntity=${updated.explanationEntity}`
                : `/login?returnUrl=${permitUrl}&parentId=${parentId}&entity=${updated.entity}&explanationEntity=${updated.explanationEntity}`;
            navigate(path);
        }
    };



    return (
        <div className="body-background">
            <div className="document-container">
                {isLoading && (
                    <div
                        style={{
                            animation: 'pulse 1.5s infinite',
                            backgroundSize: '200% 100%',
                            padding: '20px',
                            overflowY: 'auto'
                        }}
                    >
                        {Array.from({ length: 10 }).map((_, index) => (
                            <div key={index} style={{ marginBottom: '30px' }}>
                                <div style={{ width: '60%', height: '24px', marginBottom: '12px', backgroundColor: '#e0e0e0', borderRadius: '4px' }}></div>
                                <div style={{ width: '80%', height: '18px', marginBottom: '10px', backgroundColor: '#e0e0e0', borderRadius: '4px' }}></div>
                                <div style={{ width: '70%', height: '18px', marginBottom: '10px', backgroundColor: '#e0e0e0', borderRadius: '4px' }}></div>
                                <div style={{ width: '90%', height: '18px', backgroundColor: '#e0e0e0', borderRadius: '4px' }}></div>
                            </div>
                        ))}
                    </div>
                )}

                {pageData && !isLoading && (
                    <div>
                        {permitUrl && nomenclature !== null && (
                            <div className="permit-button-container">
                                <Button variant="contained" color="primary" onClick={handleStart}
                                        startIcon={<IoMdAdd/>}>
                                    განაცხადის რეგისტრაცია
                                </Button>
                            </div>
                        )}
                        <div
                            className="custom-html-container"
                            dangerouslySetInnerHTML={{
                                __html: i18n.language === 'geo'
                                    ? pageData.description
                                    : pageData.descriptionEng
                            }}
                        />
                    </div>
                )}
            </div>

            <EntitySelectorDialog
                open={showEntityDialog}
                onClose={() => {
                    setShowEntityDialog(false);
                    setSelectedEntities({entity: null, explanationEntity: null});
                }}
                onSelect={handleSelect}
                hasSecondStep={hasSecondStep}
            />
        </div>
    );
};

export default PageFetcher;
